import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {css} from "@emotion/react";
import {Image} from "@pg-design/image";

import {selectUserData} from "../../features/users/users_slice";

import jllLogo from "../../public/JLL_logo_.svg";
import jllLogoLite from "../../public/JLL_logo_lite.svg";
import logoBd from "../../public/rynek-pierwotny-pl-big-data-logo.svg";
import logoBdLite from "../../public/rynek-pierwotny-pl-big-data-logo-lite.svg";

interface IProps {
    isDark?: boolean;
    className?: string;
}

export const Brand = ({isDark, className}: IProps) => {
    const userData = useSelector(selectUserData);
    const hideJll = userData?.hide_jll === true;

    const bdHeight = isDark ? "40px" : "60px";
    const bdWidth = isDark ? "191px" : "287px";
    const jllHeight = isDark ? "40px" : "60px";
    const jllWidth = isDark ? "66px" : "99px";

    return (
        <div css={brandContainer} className={className}>
            <Link to="/">
                <Image
                    height={bdHeight}
                    width={bdWidth}
                    src={isDark ? logoBd : logoBdLite}
                    alt="Rynek Pierwotny Big Data logo"
                    loading="lazy"
                />
            </Link>
            {!hideJll && (
                <a href="https://www.jll.com" target="_blank" rel="noreferrer">
                    <Image
                        height={jllHeight}
                        width={jllWidth}
                        src={isDark ? jllLogo : jllLogoLite}
                        alt="JLL logo"
                        loading="lazy"
                    />
                </a>
            )}
        </div>
    );
};

const brandContainer = css`
    display: flex;
    align-items: center;
    gap: 1.6rem;
    width: max-content;
`;
